import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedWorkoutMovementAutoCompleteList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteWorkoutMovement {
  search?: string;
}

function useAutoCompleteWorkoutMovement({
  search,
}: IUseAutoCompleteWorkoutMovement): UseQueryResult<
  AxiosResponse<PaginatedWorkoutMovementAutoCompleteList>
> {
  const fetchAutoCompleteWorkoutMovement = (): Promise<
    AxiosResponse<PaginatedWorkoutMovementAutoCompleteList>
  > => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`workout-movements/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['workoutMovementAutoComplete', search], fetchAutoCompleteWorkoutMovement);
}

export default useAutoCompleteWorkoutMovement;
